// color-exempt-file — retokenisation Phase 6 ui-themes : dark:bg-[#0a0a0a] preserve le rendu dark historique (voir memoire ui-themes)
import React from "react";
import { useTranslation } from "react-i18next";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { SEOHead } from "./SEOHead";

interface NotFoundProps {
  title?: string;
  message?: string;
  hint?: string;
  testId?: string;
}

export default function NotFound({
  title,
  message,
  hint,
  testId = "date-polls-404",
}: NotFoundProps) {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t("not_found_title");
  const resolvedMessage = message ?? t("not_found_message");
  return (
    <div className="flex min-h-screen bg-background dark:bg-[#0a0a0a]">
      <SEOHead title={t("seo_title_notfound")} noIndex />
      <ProductSidebar productType="date" />
      <div className="flex-1">
        <ProductHeader productType="date" showAuth={true} />
        <div className="flex-1 p-8 text-center" data-testid={testId}>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            {resolvedTitle}
          </h1>
          <p className="text-muted-foreground mb-6">{resolvedMessage}</p>
          {hint && <p className="text-xs text-muted-foreground mb-6">{hint}</p>}
          <a
            href="/"
            className="inline-block px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90"
          >
            {t("back_home")}
          </a>
        </div>
      </div>
    </div>
  );
}
